module.exports = __webpack_public_path__ + "static/media/mensajes_en_cola_icon.d0509ba7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/mensajes_en_cola_icon.svg
// module id = 1796
// module chunks = 0